var path = 'search/filterSearch.html';
var html = "<ol class=\"search-suggestions u-unstyled\"> <li class=\"search-suggestion search-suggestion-circle\" data-ng-repeat=\"result in results\" data-ng-class=\"{'search-suggestion-active': current==$index}\" data-ng-mouseover=setCurrent($index) data-ng-click=selectResult(result)> {{result.name}} ({{result.count}}) </li> </ol> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/search/filterSearch.html
// module id = Z5Qe
// module chunks = 1